function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = this.closest('.section-main-product');
        this.buyButtons = this.section.querySelector('.quantity-submit-row');
        if (!this.buyButtons) return;

        this.mainProductForm = this.section.querySelector('product-form');
        this.mainProductSubmitForm = this.mainProductForm.getSubmitForm();
        this.submitForm = this.getSubmitForm();
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
        this.button = this.querySelector('.add-to-cart');

        this.throttledOnScroll = throttle(this.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
        this.updateAddToCartButton();
        this._bindAddonInfo();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      /**
       * Handles submission — validates then fires the main product form's own submit logic.
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('.js-product-form input[name="id"]').value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            theme.scrollToRevealElement(target);
          }
          return;
        }

        // Validate using the main form
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductSubmitForm.reportValidity()) {
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductSubmitForm.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Fire the main product form's submit — uses the exact same code path as the real ATC button.
        if (this.mainProductSubmitForm.requestSubmit) {
          this.mainProductSubmitForm.requestSubmit();
        } else {
          this.mainProductSubmitForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }

      /**
       * Determine visibility after scroll.
       */
      handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky')
          ? document.querySelector('.section-header').offsetHeight
          : 0;
        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset
        );

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      /**
       * Updates the image.
       */
      updateImage() {
        const mainImage = this.section.querySelector(
          '.media-gallery .main-image .slider__item.is-active .product-media img'
        );
        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      /**
       * Updates the add to cart button text.
       */
      updateAddToCartButton() {
        const variantId = this.section.querySelector('.js-product-form input[name="id"]').value;
        if (!variantId) {
          this.button.innerHTML = this.button.dataset.unavailableText;
        }
      }

      /**
       * Binds to the addon upsell toggle and shows/hides addon info in the sticky bar.
       */
      _bindAddonInfo() {
        this._addonInfoEl = this.querySelector('.satc-addon-info');
        this._addonNameEl = this.querySelector('.satc-addon-info__name');
        this._addonPriceEl = this.querySelector('.satc-addon-info__price');
        if (!this._addonInfoEl) return;

        const addonEl = document.querySelector('[data-addon-upsell]');
        if (!addonEl) return;

        const updateInfo = () => {
          const addon = addonEl.__addonInst;
          if (!addon) return;
          if (addon.active && addon.variant) {
            const price = (addon.variant.price / 100).toFixed(2);
            this._addonNameEl.textContent = (addon.product && addon.product.title) || addon.variant.title || '';
            this._addonPriceEl.textContent = '$' + price;
            this._addonInfoEl.hidden = false;
          } else {
            this._addonInfoEl.hidden = true;
          }
        };

        // Wait until __addonInst is available (it's set after connectedCallback)
        const waitForInst = setInterval(() => {
          const addon = addonEl.__addonInst;
          if (!addon) return;
          clearInterval(waitForInst);

          // Bind to the toggle's change event
          if (addon.toggleEl) {
            addon.toggleEl.addEventListener('change', updateInfo);
          }

          // Reflect initial state
          updateInfo();
        }, 50);
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}
